<div class="badge" [ngClass]="badgeStyle">
  {{ text }}
</div>
